var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "kvm-res",
      attrs: {
        "aria-label": "Resources on " + (_vm.server.name || "this server"),
        role: "group"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "kvm-res__item"
        },
        [
          _c(
            "div",
            {
              staticClass: "kvm-res__label"
            },
            [_vm._v("CPU")]
          ),
          _c(
            "div",
            {
              staticClass: "kvm-res__value"
            },
            [
              _vm.cpu != null
                ? [
                    _vm._v(_vm._s(_vm.cpu) + "% "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-res__muted"
                      },
                      [_vm._v("load")]
                    )
                  ]
                : [_vm._v("—")]
            ],
            2
          ),
          _vm.cpuSeries.length
            ? _c("kvm-sparkline", {
                staticClass: "kvm-res__spark",
                attrs: {
                  value: _vm.cpuSeries,
                  height: 22,
                  "line-width": 1.5,
                  padding: 2,
                  "max-points": 30,
                  color: _vm.cpuBusy ? _vm.lowColor : _vm.okColor
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "kvm-res__item"
        },
        [
          _c(
            "div",
            {
              staticClass: "kvm-res__label"
            },
            [_vm._v("Memory")]
          ),
          _c(
            "div",
            {
              staticClass: "kvm-res__value"
            },
            [
              _vm.ramFree != null
                ? [
                    _vm._v(_vm._s(_vm.kvmSize(_vm.ramFree)) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-res__muted"
                      },
                      [
                        _vm._v(
                          "free of " + _vm._s(_vm.kvmSize(_vm.server.ram.total))
                        )
                      ]
                    )
                  ]
                : [_vm._v("—")]
            ],
            2
          ),
          _vm.ramUsedPct != null
            ? _c("v-progress-linear", {
                staticClass: "kvm-res__bar",
                attrs: {
                  value: _vm.ramUsedPct,
                  color: _vm.barColor(_vm.ramUsedPct),
                  height: "5",
                  rounded: "",
                  "background-color": "grey lighten-2",
                  "aria-hidden": "true"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "kvm-res__item"
        },
        [
          _c(
            "div",
            {
              staticClass: "kvm-res__label"
            },
            [_vm._v("Disk")]
          ),
          _c(
            "div",
            {
              staticClass: "kvm-res__value"
            },
            [
              _vm.disk
                ? [
                    _vm._v(_vm._s(_vm.kvmSize(_vm.disk.free)) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-res__muted"
                      },
                      [_vm._v("free of " + _vm._s(_vm.kvmSize(_vm.disk.total)))]
                    )
                  ]
                : _vm.diskLoading
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "kvm-res__muted"
                      },
                      [_vm._v("Checking…")]
                    )
                  ]
                : [_vm._v("—")]
            ],
            2
          ),
          _vm.diskUsedPct != null
            ? _c("v-progress-linear", {
                staticClass: "kvm-res__bar",
                attrs: {
                  value: _vm.diskUsedPct,
                  color: _vm.barColor(_vm.diskUsedPct),
                  height: "5",
                  rounded: "",
                  "background-color": "grey lighten-2",
                  "aria-hidden": "true"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.lowNote
        ? _c(
            "p",
            {
              staticClass: "kvm-res__note",
              attrs: {
                role: "note"
              }
            },
            [_vm._v(_vm._s(_vm.lowNote))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }